import type { Tour } from '../tour-types';

/**
 * The experiments library, once it has experiments. The empty library is marked as a
 * first-run state, so the tour waits for the table. The row anchors (learnings, result,
 * status, actions) are on the first row and absent on the timeline layout; the timeline's
 * own anchors are absent on the table. The result and status columns only show on some
 * views, All among them, which is the default.
 */
export const experimentsLibraryTour: Tour = {
  key: 'experiments.library',
  version: 1,
  routes: ['/experiments/library'],
  steps: [
    {
      anchor: 'experiments-views',
      placement: 'bottom',
      title: 'Views',
      body: 'Narrow the list to Running, Draft, Ended or another status. Reset clears the view, the search and the filter in one go.',
    },
    {
      anchor: 'experiments-layout',
      placement: 'bottom',
      title: 'Table or timeline',
      body: 'The same experiments as a list, or laid out by when they ran. The timeline always shows every experiment, archived ones included.',
    },
    {
      anchor: 'experiments-filter',
      placement: 'bottom',
      title: 'Filter by learning',
      body: 'Find past tests by how they turned out, or by the mechanism they were expected to work through.',
    },
    {
      anchor: 'experiments-search',
      placement: 'bottom',
      title: 'Search',
      body: 'Searches hypotheses, notes and variant names as well as experiment names, so you can find a past test by what it was about.',
    },
    {
      anchor: 'experiments-new',
      placement: 'left',
      requires: 'experiments:create',
      title: 'Create experiment',
      body: 'Start a new draft: pick its type and name its variants. Nothing reaches visitors until you start it.',
    },
    {
      anchor: 'experiments-timeline-range',
      placement: 'bottom',
      title: 'Time window',
      body: 'How many months the timeline spans. Experiments are grouped by the pipeline they belong to, and today sits two thirds across.',
    },
    {
      anchor: 'experiments-timeline-legend',
      placement: 'bottom',
      title: 'Reading the bars',
      body: 'Colour is the status, and a dashed or faded bar is a date that is scheduled or estimated rather than past. The warning sign marks a test found to interact with another one running at the same time.',
    },
    {
      anchor: 'experiments-learnings',
      title: 'What it taught',
      body: 'Open a row to read its hypothesis, expected mechanism and result without leaving the list.',
    },
    {
      anchor: 'experiments-result',
      placement: 'left',
      title: 'Result',
      body: 'How a concluded test turned out, with the lift of its best variant over the control. Deployed means it counts as a win because a variant was shipped.',
    },
    {
      anchor: 'experiments-status',
      placement: 'left',
      title: 'Status and schedule',
      body: 'Under the status, a badge shows a scheduled start or end date, or that a schedule is Held or Needs attention. Hover a Held or Needs attention badge for the reason.',
    },
    {
      anchor: 'experiments-actions',
      placement: 'left',
      requires: 'experiments:create',
      title: 'Row actions',
      body: 'Duplicate an experiment to rerun or vary it. Only an ended experiment can be archived, and only a draft deleted.',
    },
  ],
};
